import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { appConfig } from '../config';

const { apiConfig } = appConfig;

export type SharedConstants = {
  APP_TOKEN_KEY: string;
  X_AUTH_HEADER: string;
};

let sharedConstants: SharedConstants = {
  APP_TOKEN_KEY: '',
  X_AUTH_HEADER: '',
};

export const setSharedConstants = (constants: SharedConstants) => {
  sharedConstants = constants;
};

export const getSharedConstants = () => sharedConstants;

export const mainBaseQueryFn = fetchBaseQuery({
  baseUrl: `${apiConfig.apiHost}/`,
  prepareHeaders: async (headers) => {
    const token = localStorage.getItem(sharedConstants.APP_TOKEN_KEY);
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');
    if (token) {
      headers.set(sharedConstants.X_AUTH_HEADER, token);
    }
    return headers;
  },
});

export const authBaseQueryFn = fetchBaseQuery({
  baseUrl: `${apiConfig.authHost}/`,
  prepareHeaders: async (headers) => {
    const token = localStorage.getItem(sharedConstants.APP_TOKEN_KEY);
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');
    if (token) {
      headers.set(sharedConstants.X_AUTH_HEADER, token);
    }
    return headers;
  },
});

export const tristarGamesBaseQueryFn = fetchBaseQuery({
  baseUrl: `${apiConfig.tristarGamesHost}/`,
  prepareHeaders: async (headers) => {
    const token = localStorage.getItem(sharedConstants.APP_TOKEN_KEY);
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');
    if (token) {
      headers.set(sharedConstants.X_AUTH_HEADER, token);
    }
    return headers;
  },
});

export const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let baseQueryFn = mainBaseQueryFn;

  if (typeof args === 'string' || typeof (args as FetchArgs).url === 'string') {
    const url = typeof args === 'string' ? args : (args as FetchArgs).url;

    if (url.startsWith('/api/auth') || url.startsWith('api/auth')) {
      baseQueryFn = authBaseQueryFn;
    } else if (url.startsWith('/api')) {
      baseQueryFn = mainBaseQueryFn;
    }
  }

  const result = await baseQueryFn(args, api, extraOptions);

  return result;
};
